export const useCurrentStore = () => {
  const globalStore = useGlobalStore()

  return globalStore.store
}
